import { Injectable } from '@angular/core';

import { HttpService } from '../../../tms-shared';
import { BaseCommentService } from '../comments';

@Injectable({
  providedIn: 'root',
})
export abstract class TmsWebBaseCommentService extends BaseCommentService {
  protected constructor(
    protected baseRoute: string,
    protected httpService: HttpService,
  ) {
    super(baseRoute, httpService);
  }

  protected get apiUrl() {
    return `TmsWeb/${this.baseRoute}`;
  }
}
